<template>
  <div class="index">
    <div class="bottom">
      <div class="index-con bottom-con">
        <div class="footer-left"></div>
        <div class="bottom-right">
          Copyright© FIFS & ISNFF
          <br />
          2024 International Journal Forum on Interdisciplinary Food Science (Food Bioscience & Food Nutrition) joint
          with the 16th ISNFF Conference and Exhibition
          <br />
          <img src="https://icon.cnzz.com/img/pic1.gif" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  onload() { },
  mounted() { },
  methods: {
    toOther(url) {
      this.$router.push("/" + url);
    },
  },
};
</script>

<style scoped>
.index-con {
  width: 1200px;
  /*margin: 0 auto;*/
}

.index {
  width: 100%;
}

.bottom {
  background: #333333;
  padding: 20px 0;
  color: #989898;
}

.bottom-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bottom-right {
  line-height: 2;
  font-size: 13px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .footer-right,
  .footer-left {
    display: block;
  }

  .bottom-con {
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue